import React, { useState, useEffect } from 'react';
import { useAuth } from '../fetches/AuthorizationFetch';
import '../css/LoginPage.css';
import '../css/RegistrationPage.css';

// SVG icons as constants
const BACK_ARROW_SVG = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.6891 12.1611L6.56454 7.99463L10.6891 3.82819C11.1036 3.4094 11.1036 2.73289 10.6891 2.31409C10.2745 1.8953 9.60478 1.8953 9.19021 2.31409L4.31093 7.24295C3.89636 7.66175 3.89636 8.33826 4.31093 8.75705L9.19021 13.6859C9.60478 14.1047 10.2745 14.1047 10.6891 13.6859C11.093 13.2671 11.1036 12.5799 10.6891 12.1611Z" fill="#A3AED0"/>
</svg>
`;

const SUMISNI_LOGO_SVG = `
<svg width="436" height="78" viewBox="0 0 436 78" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.3387 53.4829C24.6665 60.8152 30.3802 65.1284 39.6915 65.1284C47.3098 65.1284 53.2352 62.6483 53.2352 56.1786C53.2352 50.4637 50.2725 47.9837 37.4695 44.8566C19.2702 40.4357 13.0274 33.7503 13.0274 21.6735C13.0274 9.27325 24.4549 0 38.5276 0C52.3887 0 61.9116 6.46971 65.615 17.0369L53.4468 22.1048C51.3306 16.1743 45.7227 12.6159 38.845 12.6159C31.3325 12.6159 26.7827 15.5273 26.7827 21.8892C26.7827 27.0649 29.5337 29.3293 41.4903 32.025C59.3722 36.2304 66.9905 42.8079 66.9905 55.1003C66.9905 68.5789 55.4572 77.7443 39.7973 77.7443C25.1955 77.7443 14.2971 70.6276 10.5938 58.9822L22.3387 53.4829Z" fill="white"/>
<path d="M77.2599 47.3367V1.18611H91.0152V47.3367C91.0152 59.09 96.6231 64.5892 108.051 64.5892C119.266 64.5892 124.98 58.9822 124.98 47.3367V1.18611H138.736V47.3367C138.736 65.6675 126.673 77.7443 108.051 77.7443C88.7932 77.7443 77.2599 66.0988 77.2599 47.3367Z" fill="white"/>
<path d="M167.174 76.666H153.631V1.18611H168.762L190.453 37.5243L212.038 1.18611H226.64V76.666H212.99V23.7223L191.722 59.5213H188.548L167.174 23.5066V76.666Z" fill="white"/>
<path d="M242.404 1.18611H256.159V76.666H242.404V1.18611Z" fill="white"/>
<path d="M278.081 53.4829C280.409 60.8152 286.122 65.1284 295.434 65.1284C303.052 65.1284 308.977 62.6483 308.977 56.1786C308.977 50.4637 306.015 47.9837 293.212 44.8566C275.012 40.4357 268.769 33.7503 268.769 21.6735C268.769 9.27325 280.197 0 294.27 0C308.131 0 317.654 6.46971 321.357 17.0369L309.189 22.1048C307.073 16.1743 301.465 12.6159 294.587 12.6159C287.075 12.6159 282.525 15.5273 282.525 21.8892C282.525 27.0649 285.276 29.3293 297.232 32.025C315.114 36.2304 322.733 42.8079 322.733 55.1003C322.733 68.5789 311.199 77.7443 295.539 77.7443C280.938 77.7443 270.039 70.6276 266.336 58.9822L278.081 53.4829Z" fill="white"/>
<path d="M347.896 76.666H334.458V1.18611H347.579L381.756 52.6203V1.18611H395.299V76.666H382.179L347.896 25.124V76.666Z" fill="white"/>
<path d="M411.038 1.18611H424.794V76.666H411.038V1.18611Z" fill="white"/>
</svg>
`;



const SuccessfulRegistration = () => {
  
  const [email, setEmail] = useState('example1234@gmail.com');
  const [timer, setTimer] = useState(30);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isResending, setIsResending] = useState(false);
  
  // Calculate timer progress percentage
  const calculateProgress = () => {
    // For a circle that starts filled and empties
    return ((timer) / 30) * 100;
  };
  
  // Start timer when component mounts
  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(countdown);
          setIsButtonDisabled(false);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    
    // Clean up interval on component unmount
    return () => clearInterval(countdown);
  }, []);
  
  // Handle resend verification email
  const handleResendEmail = (e) => {
    e.preventDefault();
    
    if (isButtonDisabled) return;
    
    setIsResending(true);
    
    // Mock API call for resending verification email
    setTimeout(() => {
      setIsResending(false);
      // Reset timer after email is resent
      setTimer(30);
      setIsButtonDisabled(true);
    }, 2000);
  };
  
  // Handle back to login
  const handleBackToLogin = () => {
    window.location.href = "/login";
  };

  // Handle learn more button click
  const handleLearnMoreClick = () => {
    window.location.href = "https://google.com";
  };

  const renderMainContent = () => {
    return (
      <div className="login-container">
        <div className="login-content-wrapper">
          <div className="login-left-section">
            <div className="login-form-container">
              <div className="back-to-landing" onClick={() => window.location.href = "/"}>
                <span 
                  className="back-icon" 
                  dangerouslySetInnerHTML={{ __html: BACK_ARROW_SVG }}
                />
                <span className="back-text">Back to landing page</span>
              </div>
              <h1 className="sign-in-title">Success</h1>
              <p className="sign-in-subtitle">We have successfully created your new account.</p>
              <p className="sign-in-subtitle">But before you start you will have to activate it. We have sent an activation mail to the email you provided during registration. It should arrive in a couple of minute.</p>

              <form className="input-group">
                <div className="form-field">
                  <label className="form-label">Your email</label>
                  <input
                    className="form-input"
                    type="email"
                    placeholder="username@mail.com"
                    value={email}
                    disabled
                  />
                </div>
                
                <p className='form-label'>IF the email has not arrived during 30s you can still click the button below to resend it. We guarantee it will come this time! </p>
                
                {/* Circular Timer component */}
                <div style={{ 
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <div style={{ position: 'relative', width: '52px', height: '52px' }}>
                    {/* Background circle (gray) */}
                    <svg width="52" height="52" viewBox="0 0 52 52" style={{ position: 'absolute' }}>
                      <circle 
                        cx="26" 
                        cy="26" 
                        r="25" 
                        stroke="rgba(0, 0, 0, 0.2)" 
                        strokeWidth="2" 
                        fill="none" 
                      />
                    </svg>
                    
                    {/* Progress circle (purple) */}
                    <svg width="52" height="52" viewBox="0 0 52 52" style={{ position: 'absolute' }}>
                      <circle 
                        cx="26" 
                        cy="26" 
                        r="25" 
                        stroke="#4743E0" 
                        strokeWidth="2" 
                        fill="none" 
                        strokeDasharray={`${calculateProgress() * 1.57} 157`} 
                        strokeDashoffset="0" 
                        transform="rotate(-90 26 26)" 
                      />
                    </svg>
                    
                    {/* Text in the middle */}
                    <div style={{ 
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#4743E0',
                      fontWeight: 'bold',
                      fontSize: '18px'
                    }}>
                      {timer}s
                    </div>
                  </div>
                </div>
                
                <div className="login-actions">
                  <button 
                    type="submit"
                    className={`sign-in-button ${!isButtonDisabled ? 'active' : ''}`}
                    disabled={isButtonDisabled}
                    onClick={handleResendEmail}
                    style={{ 
                      cursor: isButtonDisabled ? 'not-allowed' : 'pointer'
                    }}
                  >
                    <span className="button-text">
                      {isResending ? 'Sending...' : 'Re-send the verification email'}
                    </span>
                  </button>
                  <span className="create-account" onClick={handleBackToLogin}>
                    <p>Do you need help?</p>
                    <p>Technical Support</p>
                  </span>
                </div>
              </form>
            </div>
            
            <div className="footer-text">
              © 2025 SUMISNI Copyright. All Rights Reserved. Designed with love by DmitriyLeo!
            </div>
          </div>
          
          <div className="login-right-section">
            <div className="right-section-content">
              <div className="right-section-image" dangerouslySetInnerHTML={{ __html: SUMISNI_LOGO_SVG }} />
              <div className="info-container">
                <button className="learn-more-button" onClick={handleLearnMoreClick}>
                  <span className="learn-text">Learn more about SUMISNI on</span>
                  <span className="website-text">sumisni.com</span>
                </button>
                <div className="terms-container-wrapper">
                  <div className="terms-container">
                    <a href="#" className="terms-text">License</a>
                    <a href="#" className="terms-text">Terms of Use</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  return (
    <div className="login-page">
      {renderMainContent()}
    </div>
  );
};

export default SuccessfulRegistration;